import {createRequest, makeRequest, prepareRequest} from "../utils/apiUtil";

export function find(text = '') {
    return makeRequest(createRequest('place'), prepareRequest({}, [], {search: text}));
}